import {
  Dimension__toString_impl_o4q1ad26wkwcghhu2zh as Dimension__toString_impl_o4q1ad,
  Dimension__hashCode_impl_p583vw23xta4b9uvomj as Dimension__hashCode_impl_p583vw,
} from './data.mjs';
import {
  equals2au1ep9vhcato as equals,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var AdaptiveToSpacingClass;
function AdaptiveToSpacing() {
  if (AdaptiveToSpacingClass === VOID) {
    class $ extends CornerRadii() {
      constructor(value) {
        super();
        this.value_1 = value;
      }
      toString() {
        return 'AdaptiveToSpacing(value=' + Dimension__toString_impl_o4q1ad(this.value_1) + ')';
      }
      hashCode() {
        return Dimension__hashCode_impl_p583vw(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AdaptiveToSpacing()))
          return false;
        if (!equals(this.value_1, other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'AdaptiveToSpacing');
    AdaptiveToSpacingClass = $;
  }
  return AdaptiveToSpacingClass;
}
var RatioOfSpacingClass;
function RatioOfSpacing() {
  if (RatioOfSpacingClass === VOID) {
    class $ extends CornerRadii() {
      constructor(value) {
        super();
        this.value_1 = value;
      }
      toString() {
        return 'RatioOfSpacing(value=' + this.value_1 + ')';
      }
      hashCode() {
        return getNumberHashCode(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RatioOfSpacing()))
          return false;
        if (!equals(this.value_1, other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'RatioOfSpacing');
    RatioOfSpacingClass = $;
  }
  return RatioOfSpacingClass;
}
var FixedClass;
function Fixed() {
  if (FixedClass === VOID) {
    class $ extends CornerRadii() {
      constructor(value) {
        super();
        this.value_1 = value;
      }
      toString() {
        return 'Fixed(value=' + Dimension__toString_impl_o4q1ad(this.value_1) + ')';
      }
      hashCode() {
        return Dimension__hashCode_impl_p583vw(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Fixed()))
          return false;
        if (!equals(this.value_1, other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Fixed');
    FixedClass = $;
  }
  return FixedClass;
}
var RatioOfSizeClass;
function RatioOfSize() {
  if (RatioOfSizeClass === VOID) {
    class $ extends CornerRadii() {}
    initMetadataForClass($, 'RatioOfSize');
    RatioOfSizeClass = $;
  }
  return RatioOfSizeClass;
}
var PerCornerClass;
function PerCorner() {
  if (PerCornerClass === VOID) {
    class $ extends CornerRadii() {
      constructor(value, topLeft, topRight, bottomLeft, bottomRight) {
        topLeft = topLeft === VOID ? false : topLeft;
        topRight = topRight === VOID ? false : topRight;
        bottomLeft = bottomLeft === VOID ? false : bottomLeft;
        bottomRight = bottomRight === VOID ? false : bottomRight;
        super();
        this.value_1 = value;
        this.topLeft_1 = topLeft;
        this.topRight_1 = topRight;
        this.bottomLeft_1 = bottomLeft;
        this.bottomRight_1 = bottomRight;
      }
      toString() {
        return 'PerCorner(value=' + Dimension__toString_impl_o4q1ad(this.value_1) + ', topLeft=' + this.topLeft_1 + ', topRight=' + this.topRight_1 + ', bottomLeft=' + this.bottomLeft_1 + ', bottomRight=' + this.bottomRight_1 + ')';
      }
      hashCode() {
        var result = Dimension__hashCode_impl_p583vw(this.value_1);
        result = imul(result, 31) + getBooleanHashCode(this.topLeft_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.topRight_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.bottomLeft_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.bottomRight_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PerCorner()))
          return false;
        if (!equals(this.value_1, other.value_1))
          return false;
        if (!(this.topLeft_1 === other.topLeft_1))
          return false;
        if (!(this.topRight_1 === other.topRight_1))
          return false;
        if (!(this.bottomLeft_1 === other.bottomLeft_1))
          return false;
        if (!(this.bottomRight_1 === other.bottomRight_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PerCorner');
    PerCornerClass = $;
  }
  return PerCornerClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var CornerRadiiClass;
function CornerRadii() {
  if (CornerRadiiClass === VOID) {
    class $ {}
    initMetadataForClass($, 'CornerRadii');
    CornerRadiiClass = $;
  }
  return CornerRadiiClass;
}
function CornerRadii_0(value) {
  return new (Fixed())(value);
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  AdaptiveToSpacing as AdaptiveToSpacing2muzuvljgg8be,
  Fixed as Fixed1p8lc8swyflir,
  PerCorner as PerCorner27xb33zgvi5gv,
  RatioOfSize as RatioOfSize1ip5bd7oxn8ba,
  RatioOfSpacing as RatioOfSpacing2du8cst35dyuc,
  CornerRadii_0 as CornerRadii1b82t7ytilhrv,
};
//endregion

//# sourceMappingURL=CornerRadii.mjs.map
